<ng-container *yatVar="isOrderToBeManaged$ | async as isOrderToBeManaged">
  <div class="container radius-0">
    <ng-container *ngIf="isPersonalizationRequired$ | async">
      <h2 class="mb-2 text-sm font-normal text-n-40">
        {{ 'commercialCheckout.overview.personalizationTitle' | transloco }}
      </h2>
      <yat-selected-person-card
        [persons]="(allPersons$ | async) ?? []"
        (cardSelect)="personCardSelected()"
        id="selected-person-card"
        yatE2EVisible></yat-selected-person-card>
      <div *ngIf="(canPersonsBeAdded$ | async) && (arePersonsSet$ | async)" class="form-group col-12 mb-2 pb-1 pl-0">
        <yat-button-add-person id="e1ca273b-5f16-4290-8341-1e819d017699" (addPerson)="personCardSelected(true)"></yat-button-add-person>
      </div>
    </ng-container>
    <h2 class="mb-2 text-sm font-normal text-n-40" *yatVar="selectedPaymentMethod$ | async as selectedPaymentMethod">
      {{ (selectedPaymentMethod ? 'paymentMethodTitle' : 'paymentMethodAddTitle') | commonPaymentWording | async }}
    </h2>
    <ng-container *ngIf="selectedPaymentMethod$ | async as selectedPaymentMethod; else noPaymentMethodSelected">
      <div class="row">
        <div class="col-12 mb-[16px]">
          <yat-payment-method-panel id="1a17f930-c357-4369-934a-edf1c8e5a790"
            [paymentMethod]="selectedPaymentMethod"
            defaultIcon="settings"
            [showEditIcon]="false"
            [showDeleteIcon]="false"
            [liveLicense]="(isLive$ | async) ?? true"
            [minified]="true"
            (selectMethod)="switchSelectedPaymentMethod()"
            matomoEventClickAction="Modify_PaymentMethod">
          </yat-payment-method-panel>
        </div>
      </div>
    </ng-container>
    <ng-template #noPaymentMethodSelected>
      <yat-add-first-payment-method id="d332ba5d-bc8d-4986-a97d-bfd05d057d5e"></yat-add-first-payment-method>
    </ng-template>

    <h2 class="mb-2 text-sm font-normal text-n-40" *ngIf="(billingAddressRequired$ | async) || (selectedBillingAddress$ | async) !== null">
      {{ 'billingAddressTitle' | commonBillingWording | async
      }}<yat-tooltip-info-icon
        iconClass="ml-1"
        tooltipClass="tooltip-l"
        [tooltipContent]="'commercialCheckout.overview.yourBillingInformationWillAppearInvoice' | transloco">
      </yat-tooltip-info-icon>
    </h2>
    <ng-container *ngIf="selectedBillingAddress$ | async as selectedBillingAddress; else noBillingAddressSelected">
      <div class="row">
        <div class="col-12">
          <yat-billing-address-panel id="242dbc71-e83e-43ec-93ef-35ad2f24f3b0"
            [billingAddress]="selectedBillingAddress"
            defaultIcon="settings"
            [showDeleteIcon]="false"
            [showEditIcon]="false"
            [liveLicense]="(isLive$ | async) ?? true"
            [minified]="true"
            (selectAddress)="switchSelectedBillingAddress()"
            matomoEventClickAction="Modify_BillingAddress">
          </yat-billing-address-panel>
        </div>
      </div>
    </ng-container>
    <ng-template #noBillingAddressSelected>
      <div class="row">
        <div class="col-12">
          <yat-no-billing-address-selected-panel id="06b5ec26-10df-44ca-9709-e54ff547baa2"
            [billingAddressRequired]="billingAddressRequired$ | async"
            (createFirstAddress)="createBillingAddress()"
            (selectExistingAddress)="switchSelectedBillingAddress()">
          </yat-no-billing-address-selected-panel>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="container purchase-panel">
    <div class="complete-purchase" *yatVar="fixedFulfillmentCountry$ | async as fixedFulfillmentCountry">
      <ng-container *ngIf="selectedLicenseType$ | async as licenseType">
        <div class="row">
          <div class="col-8">
            <yat-country-selector id="a7422538-9e92-4d3a-b43a-74ae34f5966b"
              *ngIf="!fixedFulfillmentCountry"
              [countries]="(countries$ | async) ?? []"
              [selectedCountry]="selectedCountry$ | async"
              [disableSelection]="(selectedBillingAddress$ | async) !== null"
              (countryChanged)="selectCountry($event)">
            </yat-country-selector>
          </div>
          <div class="col-4 text-right">
            <yat-license-type-selector
              *ngIf="licenseType.kind.type !== 'ONE_TIME_PURCHASE'"
              [licenseTypes]="(commercialLicenseTypes$ | async) ?? []"
              [selectedLicenseType]="licenseType"
              (licenseTypeChanged)="selectLicenseType($event)">
            </yat-license-type-selector>
          </div>
        </div>
        <div class="row mb-1 mt-1" *ngIf="licenseType.kind.type !== 'ONE_TIME_PURCHASE' || !fixedFulfillmentCountry">
          <div class="col-12">
            <div class="border-dotted d-block pb-1 mt-1 no-skeleton"></div>
          </div>
        </div>
        <yat-price-overview id="8d42238c-d834-4687-9614-ed7bd1120a36" [pricingInformation]="pricingInformation$ | async" [hideTooltip]="fixedFulfillmentCountry"> </yat-price-overview>
        <div class="row mt-[12px] mbottom-12">
          <div class="col-12" *yatVar="selectedPaymentMethod$ | async as selectedPaymentMethod">
            <ng-container
              *ngIf="
                isWalletPaymentMethodInfo(selectedPaymentMethod) && (purchaseButtonEnabled$ | async) ? selectedPaymentMethod.type : null as activeWallet;
                else purchaseButton
              ">
              <yat-wallet-button
                [walletButtonTextMode]="licenseType.kind.type === 'SUBSCRIPTION' ? 'SUBSCRIBE' : 'BUY'"
                [activeWallet]="activeWallet"
                [paymentActionFilter]="subscribeActionFilter"
                [pricingInformation]="pricingInformation$ | async"
                [debitDate]="endOfPeriod$ | async"
                [vendorName]="(vendorName$ | async) ?? ''"
                [businessModel]="(businessModel$ | async) ?? 'B2B'"
                [walletButtonEnvironment]="(isLive$ | async) && isProduction ? 'LIVE' : 'TEST'"
                (walletPaymentSuccessful)="tryPurchaseOrRenew($event)">
              </yat-wallet-button>
            </ng-container>
            <ng-template #purchaseButton>
              <button
                yat-button
                type="button"
                class="btn btn-large primary w-100"
                [yatAutoSpinner]="subscribeActionFilter"
                [disabled]="(purchaseButtonEnabled$ | async) === false"
                (click)="tryPurchaseOrRenew()"
                *yatVar="isLive$ | async as isLive"
                [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PURCHASE"
                [matomoClickAction]="
                  isOrderToBeManaged
                    ? isLive
                      ? 'Confirm_Resubscribe'
                      : 'Confirm_DemoSubscribe'
                    : licenseType.kind.type === 'ONE_TIME_PURCHASE'
                    ? isLive
                      ? 'Confirm_Purchase'
                      : 'Confirm_DemoPurchase'
                    : isLive
                    ? 'Confirm_Subscribe'
                    : 'Confirm_DemoSubscribe'
                "
                [matomoClickName]="">
                {{
                  (isOrderToBeManaged
                    ? isLive
                      ? 'commercialCheckout.overview.reSubscribeNow'
                      : 'commercialCheckout.overview.reSubscribeNowDemo'
                    : licenseType.kind.type === 'ONE_TIME_PURCHASE'
                    ? isLive
                      ? 'commercialCheckout.overview.buyNow'
                      : 'commercialCheckout.overview.buyNowDemo'
                    : isLive
                    ? 'commercialCheckout.overview.subscribeNow'
                    : 'commercialCheckout.overview.subscribeNowDemo'
                  ) | transloco
                }}
              </button>
            </ng-template>
          </div>
        </div>
        <div class="row" *ngIf="isOrderToBeManaged">
          <div class="col-12 text-center">
            <transloco
              id="ecfe4c3a-be7f-40d4-aa14-dc36e4744644"
              *yatVar="endOfPeriod$ | async as endOfPeriod"
              key="commercialCheckout.overview.nextPaymentOn"
              [params]="{ endOfPeriod: endOfPeriod ? (endOfPeriod | translocoDate) : '' }"></transloco>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p yat-link class="text-center font-small" [class.mt-1]="isOrderToBeManaged">
              <transloco
                id="73ca79a6-76d4-4df2-ad08-d9f76a456599"
                [key]="
                  licenseType.kind.type !== 'ONE_TIME_PURCHASE'
                    ? isOrderToBeManaged
                      ? 'commercialCheckout.overview.acceptingTermsAndPrivacyPolicy.reSubscription'
                      : 'commercialCheckout.overview.acceptingTermsAndPrivacyPolicy.subscription'
                    : 'commercialCheckout.overview.acceptingTermsAndPrivacyPolicy.oneTimePurchase'
                "
                [params]="{
                  name: (productCategory$ | async) === 'TRAVEL_TICKET' ? (vendorName$ | async) : (productName$ | async),
                  termsLink: {
                    url: (productLocalization$ | async)?.termsPath || YATTA_TERMS_TEMPLATE_URL,
                    class: 'link link-secondary link-underline',
                    target: '_blank',
                    trackingEvent: {
                      category: MATOMO_EVENT_CATEGORY_PURCHASE,
                      action: 'Select_LegalLinks',
                      name: 'PrivacyPolicy'
                    },
                    id: 'c089fec2-dd86-4a8e-a223-b586eea8e8f5'
                  },
                  privacyPolicyLink: {
                    url: (productLocalization$ | async)?.privacyPolicyPath || YATTA_PRIVACY_POLICY_TEMPLATE_URL,
                    class: 'link link-secondary link-underline',
                    target: '_blank',
                    trackingEvent: {
                      category: MATOMO_EVENT_CATEGORY_PURCHASE,
                      action: 'Select_LegalLinks',
                      name: 'PrivacyPolicy'
                    },
                    id: '4c59d331-fcb9-45fe-8d79-907225d1ebbc'
                  },
                  productCategory: (productCategory$ | async),
                }"></transloco>
            </p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
